import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import handleValidDate from "../../../../helpers/utils/handleValidDate";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions
import { resetAccTransState, getAccTrans as onGetAccTranss } from "../../../../store/accTrans/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../../store/paymentMethod/action";
import { resetClientState, getClient } from "../../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { resetBranchState, getBranch } from "../../../../store/branch/action";

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../../Components/Common/ExportDoc";

const ReportAccTransDaily = () => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [accTransDoc, setAccTransDoc] = useState([]);
  const dispatch = useDispatch();

  const { accTranss, isAccTransCreated, isAccTransSuccess, loading, error, companies, companyLoading, paymentMethods, clients, branches } = useSelector((state) => ({
    accTranss: state.AccTrans.accTranss,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    loading: state.AccTrans.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.AccTrans.error,
    paymentMethods: state.PaymentMethod.paymentMethods,
    clients: state.Client.clients,
    branches: state.Branch.branches,
  }));

  const [accTransList, setAccTransList] = useState([]);
  const [accTrans, setAccTrans] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const paymentMethodData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];


  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(accTranss)) setAccTransList(accTranss.filter((a) => a.at_sales && (a.at_sales.statusId === 2 || a.at_sales.statusId === 3 || a.at_sales.statusId === 4 || a.at_sales.statusId === 5)));
  }, [accTranss]);

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setUserData(obj.data);
      setUserType(obj?.data?.userType);
      setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
      setClientSelect({
        label: obj.data.client_name,
        value: obj.data.clientId
      })
      setCompanySelect({
        label: obj.data.company_name,
        value: obj.data.companyId
      })

      dispatch(resetBranchState());
      dispatch(getBranch({ status: 2, visible: true, svg: false }));

      dispatch(resetClientState());
      dispatch(getClient());
      handleGetCompany(obj.data.clientId);
      handleGetReport(obj.data.companyId);
    }
  }, [dispatch, accTrans, isSearch]);

  const handleGetReport = (id, branchId) => {
    filerIdRef.current.simple = true;
    dispatch(resetAccTransState());
    dispatch(onGetAccTranss(branchId ? { companyId: id, typeId: 1, branchId: branchId } : { companyId: id, typeId: 1, ...filerIdRef.current }));

    handleGetPaymentMethod(id, branchId);
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2, branchId: branchId, type: "Sales" }));
  };

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (filerIdRef.current && branchList.length > 0) {
      const branchSelectedDefault = branchList[0].options.find((data) => data.value === filerIdRef.current.branchId)
      setSearchBranch(branchSelectedDefault)
    }
  }, [branchList])

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const isBooked = item.isBooked;
        var obj = { label: name, value: id, isBooked: isBooked, companyId: item.companyId };
        opt.push(obj);

      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    setAccTrans(accTranss);
  }, [accTranss]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "TANGGAL",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "NAMA DEBITUR",
        isSelected: true,
        data: [],
      },
      {
        id: "at_branch",
        label: "LOKASI",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "SALES",
        isSelected: true,
        data: [],
      },
      {
        id: "at_pm",
        label: "KETERANGAN TRANSAKSI",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "JUMLAH BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (accTransList.length > 0) {
      accTransList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "at_branch" || doc.id === "accTrans_customer" || doc.id === "at_pm" || doc.id === "accTrans_agent") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "amount") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "transactionat") {
                doc.data.push(handleValidDate(value));
              } else {
                doc.data.push(value);
              }
            } else if (key === "at_sales") {
              const sales_customer = dataDoc.find((d) => d.id === "sales_customer");
              sales_customer.data.push(value?.sales_customer?.name ?? "");

              const sales_agent = dataDoc.find((d) => d.id === "sales_agent");
              sales_agent.data.push(value?.sales_agent?.name ?? "");
            }
          });
        }
      });
    }

    setAccTransDoc(dataDoc);
  }, [accTransList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = accTransList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAccTransList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = accTransList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setAccTransList(updatedData);
            }} />
        </div>
      );
    },
  },
  {
    Header: "TANGGAL",
    accessor: "transactionat",
    filterable: true,
    Cell: (data) => {
      return handleValidDate(data.row.original.transactionat);
    },
  },
  {
    Header: "NAMA DEBITUR ",
    accessor: "at_sales.sales_customer.name",
    filterable: true,
  },
  {
    Header: "LOKASI",
    accessor: "at_branch.name",
    filterable: true,
  },
  {
    Header: "SALES",
    accessor: "at_sales.sales_agent.name",
    filterable: true,
  },
  {
    Header: "KETERANGAN TRANSAKSI",
    accessor: "at_pm.name",
    filterable: true,
  },
  {
    Header: "JUMLAH",
    accessor: "amount",
    filterable: true,
    Cell: (data) => {
      return <span>{currencyFormat(data.row.original.amount === null ? 0 : data.row.original.amount)}</span>;
    },
  },
  {
    Header: "KETERANGAN",
    accessor: "description",
    filterable: true,
  },
  ], [accTransList, isCheckAll]);


  const [filterDate, setFilterDate] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = accTransList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAccTransList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => accTransList, [accTransList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = "";
    var payment = paymentMethod.value ? paymentMethod.value : "";
    const params = {
      title: searchValue,
      payment: payment,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAccTranss(params));
  }

  document.title = "Laporan Tanda Jadi Harian | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} />
      <Container fluid>
        <BreadCrumb title="Laporan Harian" pageTitle="Penjualan" />
        <Row>
          <Col lg={12}>
            <Card id="accTransList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Laporan &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={accTransDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="mb-2">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}/>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <Select
                              name="searchBranch"
                              value={searchBranch}
                              placeholder="Filter Proyek"
                              onChange={(e) => {
                                setSearchBranch(e);
                                handleGetReport(e.value);
                              }}
                              options={branchList}></Select>
                          </Col>
                          <Col sm={3}>
                            <div className="mb-2">
                              <Select
                                value={paymentMethod}
                                placeholder="Pilih Metode Bayar"
                                onChange={(e) => {
                                  setPaymentMethod(e);
                                }}
                                options={paymentMethodList}
                                name="choices-single-default"></Select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}/>
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={1}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}</td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReportAccTransDaily;
